import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	danger: {
		backgroundColor: theme.palette.error.main,
		color: '#fff',
		'&:hover': {
			background: '#f00',
		},
	},
}));

export const BaseButton = ({
	title,
	fullWidth,
	isLoading,
	onClick,
	color,
	mainColor = 'primary',
	style,
}) => {
	const classes = useStyles();

	return (
		<Button
			style={style}
			fullWidth={fullWidth}
			color={mainColor}
			className={color === 'danger' ? classes.danger : ''}
			variant='contained'
			onClick={onClick}
		>
			{isLoading ? <CircularProgress color='inherit' size={24} /> : title}
		</Button>
	);
};

BaseButton.propTypes = {
	title: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	isLoading: PropTypes.bool,
};

export default BaseButton;
